import { TCountryListResponsePayload } from 'redux/reducers/country/types';
import type { TEuDdpRecord } from 'redux/reducers/euDdp/types';
import { TEmManagementByIdFullResponse } from 'redux/reducers/emManagement/types';
import { TActivateEUDdpFormValues } from './types';

const emptyForm: TActivateEUDdpFormValues = {
	region: '',
	postalCode: '',
	streetNo: '',
	city: '',
	country: null,
	pricingPlanId: null,
	personalFixedFee: 0,
	personalPercentageFee: 0,
	postPaymentAllowed: false,
};

const resolveCountryIdByIso = (
	countryIso: string | null | undefined,
	countryList: TCountryListResponsePayload,
): number | null => {
	if (!countryList?.length || countryIso == null || countryIso === '') return null;
	const normalized = countryIso.trim().toUpperCase();
	const found = countryList.find((c) => c.isoAlpha2?.toUpperCase() === normalized);
	return found?.id ?? null;
};

export const getActivateEUDdpInitialValues = (
	em: TEmManagementByIdFullResponse | null,
	euDdpRecord: TEuDdpRecord | null | undefined,
	countryList: TCountryListResponsePayload,
): TActivateEUDdpFormValues => {
	if (!em && !euDdpRecord) {
		return { ...emptyForm };
	}

	const fromEuDdpRecord = (record: TEuDdpRecord): TActivateEUDdpFormValues => ({
		region: record.region,
		postalCode: record.postalCode,
		streetNo: record.streetNo,
		city: record.city,
		country: resolveCountryIdByIso(record.country, countryList) ?? em?.registeredCountry ?? null,
		pricingPlanId: record.pricingPlanId,
		personalFixedFee: record.personalFixedFee ?? 0,
		personalPercentageFee: record.personalPercentageFee ?? 0,
		postPaymentAllowed: record.postPaymentAllowed ?? false,
	});

	if (euDdpRecord && (!em || euDdpRecord.emId === em.id)) {
		return fromEuDdpRecord(euDdpRecord);
	}

	if (!em) {
		return { ...emptyForm };
	}

	return {
		region: '',
		postalCode: em.registeredPostalCode ?? em.regAddressPostcode ?? '',
		streetNo: em.regStreetNo ?? '',
		city: em.regAddressCity ?? '',
		country: em.registeredCountry ?? null,
		pricingPlanId: null,
		personalFixedFee: 0,
		personalPercentageFee: 0,
		postPaymentAllowed: false,
	};
};
